import { render, staticRenderFns } from "./StockEditPackaging.vue?vue&type=template&id=1f92b359"
import script from "./StockEditPackaging.vue?vue&type=script&lang=js"
export * from "./StockEditPackaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports